// Vendor libraries
import { createAction, props } from '@ngrx/store';
export const overwriteState = createAction('[Comp Table Page] Overwrite state', props());
